import Modal from 'react-bootstrap/Modal';

import { ModalButton } from '../../styles/StyledComponents';

const ConfirmationAdjustmentModal = ({ show, closeHandler, actionHandler, type, article, amount, description }) => {
    // ----- Actions
    const handleClose = () => {
        closeHandler();
    };

    const handleAction = () => {
        const payload = {
            type,
            acceptAdjustmentOverPurchase: true,
            description,
            details: [
                {
                    articleId: article.articleId,
                    amount,
                    brand: article.brand,
                },
            ],
        };

        actionHandler(payload);
    };

    // ----- Render
    return (
        <Modal show={show} backdrop='static' centered onHide={handleClose}>
            <Modal.Header className='fw-bold' closeButton>
                Mensaje de confirmación
            </Modal.Header>
            <Modal.Body>Este ajuste sobrepasa las compras del artículo. Desea continuar?</Modal.Body>
            <Modal.Footer>
                <ModalButton className='cancel' onClick={handleClose}>
                    Cancelar
                </ModalButton>
                <ModalButton className='action' onClick={handleAction}>
                    Continuar
                </ModalButton>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmationAdjustmentModal;
